module.exports = __webpack_public_path__ + "img/first_item.73710421.svg";